export default __webpack_public_path__ + "static/media/accounting-outline-16px.68e11429.svg";